export interface FilterGroup {
  displayOrder: number
  displayText: TextData
  filters: Filter[]
}

export interface Filter {
  displayOrder: number
  displayText: TextData
  keyValue: string
  values?: string[]
  type?: FilterType
  filterValue?: string | string[]
  filterId: string
}

export interface TextData {
  text: string
  i18nKey: string
}

export interface FilterType {
  id: string
  inputType: string
  type: string
}

export const filterTypes: FilterType[] = [
  {
    id: '069d4881-f7f5-46ab-826b-8fcb62e76bfe',
    inputType: 'text-field',
    type: 'number'
  } as FilterType,
  {
    id: 'd758d66e-3b1f-44cb-9450-57c2a5054e86',
    inputType: 'text-field',
    type: 'text'
  } as FilterType,
  {
    id: '8bad92de-e056-4cd9-953f-d62b895399d3',
    inputType: 'select',
    type: 'single'
  } as FilterType,
  {
    id: '03394bbf-8d35-4cbc-9b7a-80512c1d095d',
    inputType: 'select',
    type: 'multiple'
  } as FilterType,
  {
    id: '8c9bba89-eae9-4883-a3e8-50afa4dc4f82',
    inputType: 'date',
    type: 'date'
  } as FilterType,
  {
    id: '258f2902-38e5-4c39-9060-a7dd94d356b8',
    inputType: 'date',
    type: 'datetime'
  } as FilterType,
  {
    id: '258f2902-38e5-4c39-9060-a7dd94d356b8',
    inputType: 'date',
    type: 'range'
  } as FilterType,
  {
    id: '27e8bb6e-dafc-4b51-b7c8-c63340837274',
    inputType: 'date',
    type: 'time'
  } as FilterType,
  {
    id: '1337c468-88f4-48cc-9a75-ed42185b072f',
    inputType: 'checkbox',
    type: 'checkbox'
  } as FilterType
]
